// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  max-height: calc(100% - 56px) !important;
  height: 744px !important;
}

ion-radio {
  --color-checked: var(--ion-color-success);
  --color:var(--ion-color-success);
}

.questionPopoverIcon {
  color: var(--ion-color-secondary-contrast);
  zoom: 1.8;
  margin-top: 7px;
  border-radius: 50%;
}
.questionPopoverIcon:hover {
  transform: scale(1.2);
  background-color: rgba(255, 255, 255, 0.062745098);
}

.custom-popover-css {
  --width: fit-content !important;
  --max-width: 400px !important;
  color: var(--ion-color-secondary-contrast);
}

.inputfile {
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  left: 0;
  z-index: 999;
  cursor: pointer;
}

ion-img::part(image) {
  max-height: 200px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/modals/report-modal/report-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,wCAAA;EACA,wBAAA;AACF;;AAEA;EACE,yCAAA;EACA,gCAAA;AACF;;AAEA;EACE,0CAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;AACF;AAAE;EACE,qBAAA;EACA,kDAAA;AAEJ;;AAEA;EACE,+BAAA;EACA,6BAAA;EACA,0CAAA;AACF;;AAEA;EACE,UAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,YAAA;EACA,eAAA;AACF;;AAEA;EACE,iBAAA;AACF","sourcesContent":["ion-content {\n  max-height: calc(100% - 56px) !important;\n  height: 744px !important;\n}\n\nion-radio {\n  --color-checked: var(--ion-color-success);\n  --color:var(--ion-color-success);\n}\n\n.questionPopoverIcon {\n  color: var(--ion-color-secondary-contrast);\n  zoom: 1.8;\n  margin-top: 7px;\n  border-radius: 50%;\n  &:hover {\n    transform: scale(1.2);\n    background-color: #ffffff10;\n  }\n}\n\n.custom-popover-css {\n  --width: fit-content !important;\n  --max-width: 400px !important;\n  color: var(--ion-color-secondary-contrast);\n}\n\n.inputfile {\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  z-index: 999;\n  cursor: pointer\n}\n\nion-img::part(image) {\n  max-height: 200px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
